<template>
  <div class="donut-chart-loader">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 150 200"
      width="200"
      class="loader"
    >
      <defs>
        <path
          d="M146.46 73.81C146.46 113.54 114.2 145.8 74.47 145.8C34.74 145.8 2.49 113.54 2.49 73.81C2.49 34.08 34.74 1.83 74.47 1.83C114.2 1.83 146.46 34.08 146.46 73.81Z"
          id="a187zY3obG"
        />
        <path
          d="M113.84 71.76C113.84 93.48 96.2 111.12 74.47 111.12C52.75 111.12 35.11 93.48 35.11 71.76C35.11 50.03 52.75 32.4 74.47 32.4C96.2 32.4 113.84 50.03 113.84 71.76Z"
          id="cBWDMaKOE"
        />
        <path d id="i1HnPNnU2L" />
      </defs>
      <g>
        <g>
          <g>
            <g>
              <use xlink:href="#a187zY3obG" opacity="1" fill="#ececec" fill-opacity="1" />
            </g>
            <g>
              <use xlink:href="#cBWDMaKOE" opacity="1" fill="#ffffff" fill-opacity="1" />
            </g>
          </g>
          <g>
            <g>
              <use
                xlink:href="#i1HnPNnU2L"
                opacity="1"
                fill-opacity="0"
                stroke="#e9e9e9"
                stroke-width="1"
                stroke-opacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'DoughnutChartLoader',
  components: {
    ContentLoader,
  },
  computed: {
    calculatedHeight() {
      return window.innerHeight >= 900 ? 170 : window.innerHeight;
    },
  },
};
</script>
<style lang="scss">
@keyframes hideshow {
  0% {
    opacity: 1;
  }
  10% {
    opacity: 0.9;
  }
  15% {
    opacity: 0.6;
  }
  100% {
    color: #ecebeb;
    opacity: 0.2;
  }
}

.donut-chart-loader {
  display: block;
  padding-left: 10px;
  text-align: center;
  .loader {
    animation: hideshow 1.5s ease-in-out infinite;
  }
}
</style>



// WEBPACK FOOTER //
// DoughnutChartLoader.vue?44fb3ae5